import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { CtwrProcessService, CtwrComponentCategoryService } from '../../../ctwr.service';
import { BehaviorSubject } from 'rxjs';
import { FilterableService } from '../../../../mesc/filterable-service';

@Component({
  selector: 'app-processes',
  templateUrl: './processes.component.html',
  styleUrls: ['./processes.component.scss']
})
export class ProcessesComponent extends DataGridTemplate implements OnInit {
  editForm: FormGroup;
  editRowIndex: number;
  formDialog: FormDialogTemplate;
  dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  componentCategories: FilterableService = new FilterableService();

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly processService: CtwrProcessService,
    private readonly componentCategoryService: CtwrComponentCategoryService
  ) {
    super();
  }

  ngOnInit() {
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.sortable = true;
    this.filterable = 'menu';
    this.gridState.sort = [{ dir: 'asc', field: 'Name' }];

    this.formDialog.setHeight(640);
    this.formDialog.largeForm = true;
    this.formDialog.cancel = () => this.closeForm;
    this.editForm = this.getEditForm();
    this.formDialog.notificationLabel = { flag: 'info', state: 'edit', value: '*Editing this record may impact current, future, and past requests.' };
    this.formDialog.initilize(this.dialogTitle, this.editForm, this.formDialogTabs);
    this.componentCategoryService.read();
  }

  create(parentEditDataItem: any): void {
    this.componentCategoryChange([]);
    this.formDialog.isNew = true;
    this.formDialog.next(this.editDataItem);
    this.dialogTitle.next("Process");
    this.editForm.get('Name').enable();
  }

  read(opts: any): Promise<any> {
    return opts.force ?
      this.processService.read('') :
      Promise.resolve(this.processService.value);
  }

  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.processService.read(`/${dataItem.Id}`)
      .then(x => {

        if (x.ComponentCategories) {
          x.ComponentCategories.map(i => {
            const match = this.componentCategoryService.value.find(c => c.Id === i.Id);
            if (match) i.Name = match.Name;
            return i;
          })
          x.ComponentCategoryIds = x.ComponentCategories.map(c => c.Id);
          this.componentCategories.next(x.ComponentCategories);
        }
        this.formDialog.next(x);
        this.componentCategories.next(x.ComponentCategories)
      })
    this.editForm.get('Name').disable();
  }

  save(dataItem: any, isNew: boolean): Promise<any> {
    if (!dataItem.ComponentCategories) dataItem.ComponentCategories = [];
    dataItem.ComponentCategories.forEach(x => delete dataItem[x]);
    delete dataItem.ComponentCategoryIds;
    this.closeForm();
    const _path: string = isNew ? '' : (`/${dataItem.Id}`);
    return this.processService.save(dataItem, isNew, _path, false)
  }

  getEditForm(): FormGroup {
    return this.formBuilder.group({
      Id: [],
      Name: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
      ComponentCategoryIds: [],
      ComponentCategories: [],
    })
  }

  closeForm() {
    this.formDialog.editForm = this.editForm;
  }

  delete(dataItem: any): Promise<any> {
    return this.processService.remove(`/${dataItem.Id}`, false)
  }

  componentCategoryChange = (selected: any[]) => {
    const ctrl = this.editForm.get('ComponentCategories');
    let list: any[] = this.componentCategoryService.value
      .filter(cc => selected.some(x => x === cc.Id));

    if (this.formDialog.isNew) {
      list = list.map(x => {
        x.PTE = DEFAULT_PTE;
        return x;
      })
    }
    this.componentCategories.next(list);
    ctrl.setValue(list);
  }

  handlePteEdit = ({ sender, rowIndex, dataItem }) => {
    this.pteEditForm.reset(dataItem);
    sender.closeRow(this.editRowIndex);
    this.editRowIndex = rowIndex;
    sender.editRow(rowIndex, this.pteEditForm);
  }


  handlePteSave = ({ sender, rowIndex }) => {
    sender.closeRow(rowIndex);
    const ctrl = this.editForm.get('ComponentCategories');
    const value = ctrl.value;
    value[rowIndex].PTE = this.pteEditForm.value.PTE;
    ctrl.setValue(value);
  }

  pteEditForm = this.formBuilder.group({ PTE: [Validators.required] });

  columns: any[] = [
    {
      field: 'Name',
      title: 'Name',
    },
    {
      field: 'CategoryNames',
      title: 'Categories',
    },
  ]

  formControls = [
    {
      type: 'text',
      title: 'Process Name',
      name: 'Name',
      textField: 'Description',
      valueField: 'Id',
      placeholder: 'Enter a Process Name',
      stretch: true,
      invalidText: 'Invalid Input. Name must be between 1 and 65 characters.',
    },
    {
      type: "multiselect",
      title: "Categories",
      name: "ComponentCategoryIds",
      textField: "Name",
      valueField: "Id",
      service: this.componentCategoryService,
      onChange: this.componentCategoryChange,
      stretch: true
    },
    {
      type: 'grid',
      name: 'ComponentCategories',
      service: this.componentCategories,
      stretch: true,
      controls: {
        edit: false
      },
      editForm: this.pteEditForm,
      columns: [
        {
          field: 'Name',
          title: 'Category',
        },
        {
          field: 'PTE',
          title: 'PTE',
        },
      ]
    }
  ]

  formDialogTabs = [
    {
      title: "Processes",
      selected: true,
      formControls: this.formControls
    },
  ]
}

const DEFAULT_PTE = 'PTE1';
